import { TakipEntity } from "@/entity/TakipEntity";
import { AlacakEntity } from "@/entity/AlacakBelgeler/AlacakEntity";
import { FaizTuruEntity } from "@/entity/FaizTuruEntity";
import { AlacakKalemiAlaniEntity } from "@/entity/AlacakKalemiAlaniEntity";
import Vue from 'vue';
import Vuex from 'vuex';
import TakipEkleService from "@/services/takipEkleService";

Vue.use(Vuex);

type FaizDataType = {
  hesaplanabilir: boolean;
  data: TakipEntity | { message: string };
};

interface TarafDataType {
  isGetted: boolean;
  data: any[];
}

export interface TakipEkleState {
  isIkili: boolean;
  item: TakipEntity;
  faizData: FaizDataType;
  kiraKontrati: Array<AlacakEntity>;
  takipBorclular: TarafDataType;
  takipAlacaklilar: TarafDataType;
  takipAlacaklar: TarafDataType;
  takipIsler: TarafDataType;
  fab: boolean;
  show1: boolean;
  show2: boolean;
  hover: boolean;
  faizLoading: boolean;
  borcluEklemeLoading: boolean;
  alacakliEklemeLoading: boolean;
  isListesiLoading: boolean;
  alacaklilarLoading: boolean;
  borclularLoading: boolean;
  alacaklarLoading: boolean;
  islerLoading: boolean;
  selectedAlacakli: any;
  selectedBorclu: any;
  selectedAlacak: any;
  selectedIs: any;
  takipOncesiFaizTurleriMap: Record<number, FaizTuruEntity>;
  alacakKalemiAlanlariMap: Record<number, AlacakKalemiAlaniEntity>;
}

const emptyTarafData: TarafDataType = { isGetted: false, data: [] };

const initialState: TakipEkleState = {
  isIkili: false,
  item: new TakipEntity(),
  faizData: { hesaplanabilir: false, data: { message: '' } },
  kiraKontrati: [],
  takipBorclular: { ...emptyTarafData },
  takipAlacaklilar: { ...emptyTarafData },
  takipAlacaklar: { ...emptyTarafData },
  takipIsler: { ...emptyTarafData },
  fab: false,
  show1: false,
  show2: false,
  hover: false,
  faizLoading: false,
  borcluEklemeLoading: false,
  alacakliEklemeLoading: false,
  isListesiLoading: false,
  alacaklilarLoading: false,
  borclularLoading: false,
  alacaklarLoading: false,
  islerLoading: false,
  selectedAlacakli: null,
  selectedBorclu: null,
  selectedAlacak: null,
  selectedIs: null,
  takipOncesiFaizTurleriMap: {},
  alacakKalemiAlanlariMap: {}
};

const state: TakipEkleState = { ...initialState };

const mutations = {
  resetState(state: TakipEkleState) {
    console.log('[resetState] çağrıldı');
    for (const key of Object.keys(initialState)) {
      const stateKey = key as keyof TakipEkleState;
      state[stateKey] = Array.isArray(initialState[stateKey])
          ? [...initialState[stateKey]]
          : JSON.parse(JSON.stringify(initialState[stateKey]));
    }
  },
  setIsIkili(state: TakipEkleState, value: boolean) {
    state.isIkili = value;
  },
  setItem(state: TakipEkleState, value: TakipEntity) {
    state.item = value;
  },
  ADD_IS_TO_LIST(state: TakipEkleState, isItem: any) {
    if (state.takipIsler && state.takipIsler.data) {
      state.takipIsler.data.push(isItem);
    } else {
      state.takipIsler = { isGetted: true, data: [isItem] };
    }
  },
  UPDATE_IS_IN_LIST(state: TakipEkleState, updatedIs: any) {
    if (state.takipIsler && state.takipIsler.data) {
      const index = state.takipIsler.data.findIndex(item => item.id === updatedIs.id);
      if (index !== -1) {
        state.takipIsler.data.splice(index, 1, updatedIs);
      }
    }
  },
  REMOVE_IS_FROM_LIST(state: TakipEkleState, isId: number) {
    if (state.takipIsler && state.takipIsler.data) {
      state.takipIsler.data = state.takipIsler.data.filter(item => item.id !== isId);
    }
  },
  setFaizData(state: TakipEkleState, value: FaizDataType) {
    state.faizData = value;
    state.faizLoading = false;
  },
  setKiraKontrati(state: TakipEkleState, value: Array<AlacakEntity>) {
    state.kiraKontrati = value;
  },
  setTakipBorclular(state: TakipEkleState, value: TarafDataType) {
    // Her borçlunun vekiller, tebligatlar, borclu_bilgileri ve adresler field'larını initialize et
    if (value && value.data && Array.isArray(value.data)) {
      value.data = value.data.map(borclu => ({
        ...borclu,
        vekiller: borclu.vekiller || [],
        tebligatlar: borclu.tebligatlar || [],
        borclu_bilgileri: borclu.borclu_bilgileri || null,
        adresler: borclu.adresler || [],
        varsayilan_adres: borclu.varsayilan_adres || null
      }));
    }
    state.takipBorclular = value || { ...emptyTarafData };
  },
  setTakipAlacaklilar(state: TakipEkleState, value: TarafDataType) {
    state.takipAlacaklilar = value || { ...emptyTarafData };
  },
  setTakipAlacaklar(state: TakipEkleState, value: TarafDataType) {
    state.takipAlacaklar = value || { ...emptyTarafData };
  },
  setTakipIsler(state: TakipEkleState, value: TarafDataType) {
    state.takipIsler = value || { ...emptyTarafData };
  },
  setFaizLoading(state: TakipEkleState, value: boolean) {
    state.faizLoading = value;
  },
  setBorcluEklemeLoading(state: TakipEkleState, value: boolean) {
    state.borcluEklemeLoading = value;
  },
  setAlacakliEklemeLoading(state: TakipEkleState, value: boolean) {
    state.alacakliEklemeLoading = value;
  },
  setShow1(state: TakipEkleState, value: boolean) {
    state.show1 = value;
  },
  setShow2(state: TakipEkleState, value: boolean) {
    state.show2 = value;
  },
  setFab(state: TakipEkleState, value: boolean) {
    state.fab = value;
  },
  setAlacaklilarLoading(state: TakipEkleState, value: boolean) {
    state.alacaklilarLoading = value;
  },
  setBorclularLoading(state: TakipEkleState, value: boolean) {
    state.borclularLoading = value;
  },
  setAlacaklarLoading(state: TakipEkleState, value: boolean) {
    state.alacaklarLoading = value;
  },
  setIslerLoading(state: TakipEkleState, value: boolean) {
    state.islerLoading = value;
  },
  setSelectedAlacakli(state: TakipEkleState, value: any) {
    state.selectedAlacakli = value;
  },
  setSelectedBorclu(state: TakipEkleState, value: any) {
    state.selectedBorclu = value;
  },
  setSelectedAlacak(state: TakipEkleState, value: any) {
    state.selectedAlacak = value;
  },
  setSelectedIs(state: TakipEkleState, value: any) {
    state.selectedIs = value;
  },
  settakipOncesiFaizTurleriMap(state: TakipEkleState, value: Record<number, FaizTuruEntity>) {
    state.takipOncesiFaizTurleriMap = value;
  },
  setAlacakKalemiAlanlariMap(state: TakipEkleState, value: Record<number, AlacakKalemiAlaniEntity>) {
    state.alacakKalemiAlanlariMap = value;
  },
  setBorcluVekiller(state: TakipEkleState, payload: { borcluId: number, vekiller: any[] }) {
    if (state.takipBorclular && state.takipBorclular.data) {
      const borclu = state.takipBorclular.data.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.vekiller = payload.vekiller;
      }
    }
  },
  setBorcluTebligatlar(state: TakipEkleState, payload: { borcluId: number, tebligatlar: any[] }) {
    if (state.takipBorclular && state.takipBorclular.data) {
      const borclu = state.takipBorclular.data.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.tebligatlar = payload.tebligatlar;
      }
    }
  },
  setBorcluBilgileri(state: TakipEkleState, payload: { borcluId: number, borclu_bilgileri: any }) {
    if (state.takipBorclular && state.takipBorclular.data) {
      const borclu = state.takipBorclular.data.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.borclu_bilgileri = payload.borclu_bilgileri;
      }
    }
  },
  setBorcluAdresler(state: TakipEkleState, payload: { borcluId: number, adresler: any[], varsayilan_adres: any }) {
    if (state.takipBorclular && state.takipBorclular.data) {
      const borclu = state.takipBorclular.data.find(b => b.id === payload.borcluId);
      if (borclu) {
        borclu.adresler = payload.adresler;
        borclu.varsayilan_adres = payload.varsayilan_adres;
      }
    }
  }
};

const actions = {
  async loadTakipBilgileri(context: any, id: string) {
    const { commit, dispatch } = context;
    if (!id) {
      commit('resetState');
      return false;
    }
    try {
      const tumVeriler = await TakipEkleService.getTakipTumVeriler(id);
      if (!tumVeriler.takip) throw new Error('Takip verisi boş geldi');
      await dispatch('ensureFaizTurleri');
      commit('setItem', tumVeriler.takip);
      commit('setTakipAlacaklilar', tumVeriler.alacaklilar);
      commit('setTakipBorclular', tumVeriler.borclular);
      if (tumVeriler.borclular && tumVeriler.borclular.data && tumVeriler.borclular.data.length > 0) {
        await dispatch('loadBorcluVekillerVeTebligatlar', tumVeriler.borclular.data);
      }
      commit('setTakipAlacaklar', tumVeriler.alacaklar);
      commit('setTakipIsler', tumVeriler.isListesi);

      commit('setFaizLoading', false);
      return true;
    } catch (error) {
      commit('resetState');
      commit('setFaizLoading', false);
      return false;
    }
  },
  async loadBorcluVekillerVeTebligatlar({ commit }: { commit: any }, borclular: any[]) {
    // Her borçlu için paralel olarak vekiller, tebligatlar, borçlu bilgileri ve adresleri yükle
    const promises = borclular.map(async (borclu) => {
      if (!borclu.id) return;

      try {
        // Tüm verileri paralel olarak çek
        const [vekiller, tebligatlar, borclu_bilgileri, adresData] = await Promise.all([
          TakipEkleService.getVekillerByBorcluId(borclu.id),
          TakipEkleService.getTebligatlarByBorcluId(borclu.id),
          TakipEkleService.getBorcluBilgileriById(borclu.id),
          TakipEkleService.getAdreslerByBorcluId(borclu.id)
        ]);

        // Store'da ilgili borçlunun tüm verilerini güncelle
        commit('setBorcluVekiller', { borcluId: borclu.id, vekiller });
        commit('setBorcluTebligatlar', { borcluId: borclu.id, tebligatlar });
        commit('setBorcluBilgileri', { borcluId: borclu.id, borclu_bilgileri });
        commit('setBorcluAdresler', {
          borcluId: borclu.id,
          adresler: adresData.adresler,
          varsayilan_adres: adresData.varsayilan_adres
        });
      } catch (error) {
        console.error(`Borçlu ${borclu.id} için veriler yüklenirken hata:`, error);
      }
    });

    // Tüm borçluların verileri yüklenene kadar bekle
    await Promise.all(promises);
  },
  async ensureFaizTurleri({ state, commit }: { state: TakipEkleState, commit: any }) {
    if (state.takipOncesiFaizTurleriMap && Object.keys(state.takipOncesiFaizTurleriMap).length > 0) {
      return state.takipOncesiFaizTurleriMap;
    }
    try {
      const response = await Vue.prototype.$http.get('/api/v1/faiz-tur-list');
      const map: Record<number, FaizTuruEntity> = {};
      const list = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      list.forEach((item: any) => {
        if (item && item.id != null) {
          map[item.id] = item;
        }
      });
      commit('settakipOncesiFaizTurleriMap', map);
      return map;
    } catch (error) {
      console.error('Faiz türleri yüklenirken hata oluştu:', error);
      return state.takipOncesiFaizTurleriMap;
    }
  },
  async updateSingleComponent(context: any, { id, componentType }: { id: string, componentType: string }) {
    const { commit, dispatch } = context;
    if (!id || !componentType) return false;
    try {
      let updatedData = null;
      switch (componentType) {
        case 'alacaklilar':
          commit('setAlacaklilarLoading', true);
          updatedData = await TakipEkleService.getAlacaklilarByTakipId(id);
          commit('setTakipAlacaklilar', updatedData);
          commit('setAlacaklilarLoading', false);
          break;
        case 'borclular':
          commit('setBorclularLoading', true);
          updatedData = await TakipEkleService.getBorcluByTakipId(id);
          commit('setTakipBorclular', updatedData);
          if (updatedData && updatedData.data && updatedData.data.length > 0) {
            await dispatch('loadBorcluVekillerVeTebligatlar', updatedData.data);
          }
          commit('setBorclularLoading', false);
          break;
        case 'alacaklar':
          await dispatch('ensureFaizTurleri');
          commit('setAlacaklarLoading', true);
          updatedData = await TakipEkleService.getAlacaklarByTakipId(id);
          commit('setTakipAlacaklar', updatedData);
          commit('setAlacaklarLoading', false);
          break;
        case 'isListesi':
          commit('setIslerLoading', true);
          updatedData = await TakipEkleService.getIsListesiByTakipId(id);
          commit('setTakipIsler', updatedData);
          commit('setIslerLoading', false);
          break;
        default:
          return false;
      }
      return true;
    } catch (error) {
      commit('setAlacaklilarLoading', false);
      commit('setBorclularLoading', false);
      commit('setAlacaklarLoading', false);
      commit('setIslerLoading', false);
      return false;
    }
  },
  loadKiraKontrati(context: any, data: Array<AlacakEntity>) {
    const { commit } = context;
    commit('setKiraKontrati', data);
  },

  async getFaizData(context: any, { id }: { id: string }) {
    const { commit, state } = context;
    commit('setFaizData', {
      hesaplanabilir: false,
      data: { message: '' }
    });
    try {
      const raw = await TakipEkleService.getFaizDataByTakipId(id);
      if (!raw || raw.hesaplanabilir === false) {
        commit('setFaizData', {
          hesaplanabilir: false,
          data: raw && raw.data ? raw.data : { message: 'Kapak hesabı verileri alınırken bir hata oluştu' }
        });
        return false;
      }
      const data = Array.isArray(raw) && raw.length > 0 ? raw[0] : raw;
      const takipObj = (data && typeof data === 'object')
          ? { ...JSON.parse(JSON.stringify(state.item)), ...(data.takip_bilgileri || data) }
          : JSON.parse(JSON.stringify(state.item));
      commit('setFaizData', {
        hesaplanabilir: true,
        data: takipObj
      });
      return true;
    } catch (error) {
      commit('setFaizData', {
        hesaplanabilir: false,
        data: { message: 'Kapak hesabı verileri alınırken bir hata oluştu' }
      });
      return false;
    } finally {
      commit('setFaizLoading', false);
    }
  },
  async updateTakip({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.updateTakipBilgileri(payload);
    await dispatch('getFaizData', { id: payload.id });
  },
  async addAlacakli({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.addAlacakli(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async removeAlacakli({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.removeAlacakli(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async addBorclu({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.addBorclu(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async removeBorclu({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.removeBorclu(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async addAlacak({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.addAlacak(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async removeAlacak({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.removeAlacak(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async updateAlacak({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.updateAlacak(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async copyAlacak({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.copyAlacak(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async updateAltTipHesap({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.updateAltTipHesap(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async addTahsilat({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.addTahsilat(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },
  async addMasraf({ dispatch }: { dispatch: any }, payload: any) {
    await TakipEkleService.addMasraf(payload);
    await dispatch('getFaizData', { id: payload.takipId });
  },

  async updateTakipTalebi({ commit, dispatch }: { commit: any, dispatch: any }, payload: any) {
    try {
      commit('setFaizLoading', true);
      const response = await TakipEkleService.updateTakipTalebi(payload);

      if (response && response.data) {
        const updatedTakip = { ...state.item };
        if (updatedTakip.takip_bilgileri && updatedTakip.takip_bilgileri.talepler && updatedTakip.takip_bilgileri.talepler.length > 0) {
          const talepIndex = updatedTakip.takip_bilgileri.talepler.findIndex((t: any) => t.id === payload.id);
          if (talepIndex !== -1) {
            updatedTakip.takip_bilgileri.talepler[talepIndex] = {
              ...updatedTakip.takip_bilgileri.talepler[talepIndex],
              ...response.data
            };
            commit('setItem', updatedTakip);
          }
        }
      }

      await dispatch('getFaizData', { id: payload.takip_id });
      return response;
    } catch (error) {
      console.error('Takip talebi güncellenirken hata:', error);
      commit('setFaizLoading', false);
      throw error;
    }
  },

  async addIs({ commit }: { commit: any }, payload: any) {
    const response = await TakipEkleService.addIsListesi(payload);
    if (response && response.data) {
      commit('ADD_IS_TO_LIST', response.data);
    }
    return response;
  },

  async updateIs({ commit }: { commit: any }, payload: any) {
    const response = await TakipEkleService.updateIsListesi(payload);
    if (response && response.data) {
      commit('UPDATE_IS_IN_LIST', response.data);
    }
    return response;
  },

  async removeIs({ commit }: { commit: any }, payload: any) {
    await TakipEkleService.removeIsListesi(payload);
    commit('REMOVE_IS_FROM_LIST', payload.id);
    return true;
  }
}

const getters = {
  item: (state: TakipEkleState) => state.item,
  isIkili: (state: TakipEkleState) => state.isIkili,
  takipAlacaklilar: (state: TakipEkleState) => state.takipAlacaklilar,
  takipBorclular: (state: TakipEkleState) => state.takipBorclular,
  takipAlacaklar: (state: TakipEkleState) => state.takipAlacaklar,
  takipIsler: (state: TakipEkleState) => state.takipIsler,
  faizData: (state: TakipEkleState) => state.faizData,
  faizLoading: (state: TakipEkleState) => state.faizLoading,
  takipOncesiFaizTurleriMap: (state: TakipEkleState) => state.takipOncesiFaizTurleriMap,
  alacakKalemiAlanlariMap: (state: TakipEkleState) => state.alacakKalemiAlanlariMap,
  alacaklilarLoading: (state: TakipEkleState) => state.alacaklilarLoading,
  borclularLoading: (state: TakipEkleState) => state.borclularLoading,
  alacaklarLoading: (state: TakipEkleState) => state.alacaklarLoading,
  islerLoading: (state: TakipEkleState) => state.islerLoading,
  fab: (state: TakipEkleState) => state.fab,
  hasTakipId: (state: TakipEkleState) => !!(state.item?.id || state.item?.takip_bilgileri?.id),
  hasAlacakliData: (state: TakipEkleState) => state.takipAlacaklilar && Array.isArray(state.takipAlacaklilar.data) && state.takipAlacaklilar.data.length > 0,
  hasBorcluData: (state: TakipEkleState) => state.takipBorclular && Array.isArray(state.takipBorclular.data) && state.takipBorclular.data.length > 0,
  hasAlacakData: (state: TakipEkleState) => state.takipAlacaklar && Array.isArray(state.takipAlacaklar.data) && state.takipAlacaklar.data.length > 0,
  hasIsListesiData: (state: TakipEkleState) => state.takipIsler && Array.isArray(state.takipIsler.data) && state.takipIsler.data.length > 0,
  selectedAlacakli: (state: TakipEkleState) => state.selectedAlacakli,
  selectedBorclu: (state: TakipEkleState) => state.selectedBorclu,
  selectedAlacak: (state: TakipEkleState) => state.selectedAlacak,
  selectedIs: (state: TakipEkleState) => state.selectedIs
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
